import { Colors } from '@ab-core/colors';
import { FormElementHeight } from '@ab-core/forms';
import { RADIUS } from '@ab-core/radius';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const Label = styled.label`
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    gap: ${SPACING.SMALL_2};
    &.ab-checkbox-label-size-normal {
        height: ${FormElementHeight.Normal}px;
    }
    &.ab-checkbox-label-disabled {
        cursor: default;
    }
`;

export const CheckboxContainer = styled.div`
    position: relative;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;
    border: 1px solid ${Colors.gray70};
    background: ${Colors.white};
    border-radius: ${RADIUS.MINIMAL};
    width: 20px;
    height: 20px;
    &.ab-checkbox-container-checked {
        background: ${Colors.primary};
        border-color: ${Colors.primary};
    }
    &.ab-checkbox-container-disabled {
        border-color: ${Colors.gray30};
        &.ab-checkbox-container-checked {
            background: ${Colors.gray30};
        }
    }
    &.ab-checkbox-container-error {
        border-color: ${Colors.error};
        &.ab-checkbox-container-checked {
            background: ${Colors.error};
        }
    }
`;

export const Checkbox = styled.input`
    opacity: 0;
    position: absolute;
    border: none;
    margin: 0;
    padding: 0;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
`;

export const LabelContainer = styled.div`
    color: inherit;
    &.ab-checkbox-label-container-error {
        color: ${Colors.error};
    }
`;
